import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { StudentInternshipModel } from "common/models/page-models/student-side/internship/student-internship-data.model";
import { StudentInternshipListingModel } from "common/models/page-models/student-side/internship/student-internship-grid-model";
import { GridResolver } from "common/resolvers/core-resolvers/grid.resolver";
import { SystemService } from "common/services/core-services/system.service";
import { StudentInternshipWidgetService } from "common/widget/student-side/student-internship/student-internship.service";

 
@Injectable({
    providedIn: 'root'
})
export class StudentInternshipGridResolver extends GridResolver<StudentInternshipModel, StudentInternshipListingModel> {
    constructor(
        protected ss: StudentInternshipWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(ss, router, systemService);
       
    }
    

    
}